module.exports = __webpack_public_path__ + "static/img/login-head.401ae1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-head.png
// module id = rMD3
// module chunks = 1